import { render, staticRenderFns } from "./limitJustificationModal.vue?vue&type=template&id=582e0442&"
import script from "./limitJustificationModal.vue?vue&type=script&lang=js&"
export * from "./limitJustificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports